import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import UserService2 from '@/services/UserService2'

export default function useUserCreatePage() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [submitting, setSubmitting] = useState(false)

	const handleCancel = useCallback(() => {
		navigate('/system/uzytkownicy')
	}, [navigate])

	const handleSubmit = useCallback(async payload => {
		if (submitting) return false

		setSubmitting(true)
		const result = await UserService2.create(payload)

		if (!result.success) {
			await Swal.fire({
				title: t('notifications.errorTitle'),
				text: result.error || t('settingsPage.users.messages.createFailed'),
				icon: 'error',
			})
			setSubmitting(false)
			return false
		}

		await Swal.fire({
			title: t('notifications.successTitle'),
			text: t('settingsPage.users.messages.createdSuccess', { name: payload.nazwa }),
			icon: 'success',
		})

		setSubmitting(false)
		navigate('/system/uzytkownicy')
		return true
	}, [navigate, submitting, t])

	return {
		handleCancel,
		handleSubmit,
		submitting,
	}
}
